import type { LucideIcon } from 'lucide-react';
import {
  Activity,
  Banknote,
  BookOpen,
  Bookmark,
  Building,
  Building2,
  Calendar,
  CalendarCheck,
  CircleHelp,
  Clock,
  Cloud,
  CreditCard,
  DoorOpen,
  Dumbbell,
  Filter,
  Inbox,
  KeyRound,
  Layers,
  LayoutDashboard,
  LayoutGrid,
  List,
  ListTodo,
  Mail,
  MapPin,
  MessageCircle,
  Palette,
  Percent,
  ScrollText,
  Settings,
  Shield,
  Smartphone,
  ScanQrCode,
  Tags,
  TestTube2,
  Ticket,
  UserCircle,
  UserCog,
  Users,
  UserRound,
  UserX,
  Wallet,
  Webhook,
  Home
} from 'lucide-react';
import { ROUTE_PATHS } from '../../app/router/route-paths';
import type { StaffSPARoutePath } from '../../shared/access/staff-spa-route-paths';

const ICONS: Partial<Record<StaffSPARoutePath, LucideIcon>> & Record<string, LucideIcon> = {
  '/': Home,
  '/superadmin/dashboard': LayoutDashboard,
  '/superadmin/users': Users,
  '/superadmin/users/platform': Users,
  '/superadmin/users/clients': UserRound,
  '/superadmin/users/roles': Shield,
  '/superadmin/platform-users': Users,
  '/superadmin/clients-catalog': UserRound,
  '/tenant/dashboard': LayoutDashboard,
  '/fitness/dashboard': LayoutDashboard,
  '/staff/dashboard': LayoutDashboard,
  '/organization': Building2,
  [ROUTE_PATHS.organizationProfileEdit]: Settings,
  '/organization/settings': Settings,
  '/subscription': Percent,
  '/organization/branches': MapPin,
  '/organization/services': List,
  '/services-types': Tags,
  '/services-list': List,
  '/services-spaces': DoorOpen,
  '/equipment': Dumbbell,
  '/subscriptions': Ticket,
  '/schedule': Calendar,
  '/schedule-workhours': Clock,
  '/bookings': Bookmark,
  '/clients-bookings': CalendarCheck,
  '/payments': Wallet,
  '/application': Smartphone,
  '/global-widget-theme': Palette,
  '/clients': Users,
  '/staff': UserRound,
  '/sales-funnel': Filter,
  '/sales-funnel-settings': Settings,
  '/tasks': ListTodo,
  '/assistant': Cloud,
  '/superadmin/assistant': Cloud,
  '/automation-sources': Webhook,
  '/automation-incoming': Inbox,
  '/incoming-requests': Inbox,
  '/audit-log': ScrollText,
  '/audit-payments': Banknote,
  '/pending-auth': UserX,
  '/docs': BookOpen,
  [ROUTE_PATHS.contact]: Mail,
  [ROUTE_PATHS.feedback]: MessageCircle,
  '/payment-gateways': CreditCard,
  '/admin-tokens': KeyRound,
  '/settings': Settings,
  '/platform-plans': Layers,
  '/tariffs': Percent,
  '/all-users': UserCog,
  '/users': UserCog,
  '/access-rbac': Shield,
  '/platform-organizations': Building,
  [ROUTE_PATHS.superadmin]: LayoutGrid,
  '/widget-embed-lab': TestTube2,
  '/fitness': Activity,
  '/platform-qrcode-config': ScanQrCode,
  [ROUTE_PATHS.me]: UserCircle,
  [ROUTE_PATHS.controls]: LayoutGrid
};

export function staffNavIconForPath(
  path: StaffSPARoutePath | typeof ROUTE_PATHS.controls | typeof ROUTE_PATHS.superadmin
): LucideIcon {
  const p = path as string;
  if (p.startsWith('/yc-')) return Cloud;
  return ICONS[p] ?? CircleHelp;
}
